import { EditBase, Form } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { DeleteButton } from "@/components/admin/delete-button";
import { FormToolbar } from "../layout/FormToolbar";

import { LoadInputs } from "./LoadInputs";

export const LoadEdit = () => {
  return (
    <EditBase redirect="show">
      <div className="mt-2 mb-12 flex flex-col gap-4 w-full">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">Edit Load</h1>
          <DeleteButton redirect="list" confirm confirmTitle="Delete this load?" confirmContent="This load will be marked as deleted and hidden from the list. It can be recovered by an administrator via the database." />
        </div>
        <Form>
          <Card>
            <CardContent className="pt-6">
              <LoadInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>
      </div>
    </EditBase>
  );
};
